import { format as ft } from 'date-fns';

export const createMaintenanceFields = [
  {
    title: 'Maintenance.CreateM.PrDet',
  },
  {
    label: 'Maintenance.CreateM.name1',
    field: 'name1',
    placeholder: 'Name',
    required: true,
    type: 'text',
    value: '',
    requiredText: 'Name is required',
  },
  {
    label: 'Maintenance.CreateM.project',
    field: 'project',
    required: true,
    type: 'select',
    options: [],
    value: '',
    requiredText: 'Please select Project name',
    disabled: false,
    translate: false,
  },
  {
    label: 'Maintenance.CreateM.project_id',
    field: 'project_id',
    placeholder: 'Project ID',
    required: false,
    type: 'text',
    disabled: true,
    value: '',
    requiredText: 'Project ID is required',
  },
  {
    label: 'Maintenance.CreateM.project_location',
    field: 'project_location',
    placeholder: 'Project Location',
    required: false,
    type: 'text',
    value: '',
    disabled: true,
    requiredText: 'Project Location is required',
  },
  {
    label: 'Maintenance.CreateM.asset',
    field: 'asset',
    required: true,
    type: 'select',
    options: [],
    value: '',
    requiredText: 'Asset name required',
    disabled: false,
  },
  {
    label: 'Maintenance.CreateM.target_date',
    field: 'target_date',
    required: true,
    type: 'date',
    value: '',
    requiredText: 'Please select date',
  },
  {
    label: 'Maintenance.CreateM.maintenance_type',
    field: 'maintenance_type',
    required: true,
    type: 'select',
    options: ['Routine', 'Non-Routine'],
    value: '',
    requiredText: 'Please select Maintenance Type',
  },
  {
    label: 'Maintenance.CreateM.visit_datetime',
    field: 'visit_datetime',
    required: true,
    type: 'datetime-local',
    value: ft(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    requiredText: 'Please select Visit DateTime',
  },
  {
    label: 'Maintenance.CreateM.priority',
    field: 'priority',
    required: true,
    type: 'select',
    options: ['Critical', 'Medium', 'Low'],
    value: '',
    requiredText: 'Please select Priority',
  },
  {
    title: 'Maintenance.Detail.MDet',
  },
  {
    label: 'Maintenance.CreateM.period',
    field: 'period',
    required: true,
    type: 'select',
    options: ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Half-yearly', 'Yearly'],
    value: '',
    requiredText: 'Please select the Time Period',
    hide: true
  },
  {
    label: 'Maintenance.CreateM.type_of_employee',
    field: 'type_of_employee',
    required: false,
    type: 'select',
    options: ['Internal', 'External', 'Contractual'],
    value: '',
    requiredText: 'Pleas select the employee type',
  },

  {
    label: 'Maintenance.CreateM.functional_status',
    field: 'functional_status',
    required: true,
    type: 'select',
    options: ['Working', 'Not Working', 'Need Improvement', 'Not Applicable'],
    value: '',
    requiredText: 'Please select Functional Status',
  },
  {
    label: 'Maintenance.CreateM.status',
    field: 'status',
    required: true,
    type: 'select',
    options: ['New', 'In Progress', 'Completed', 'Need Repair'],
    value: '',
    requiredText: 'Please select Status',
  },

  {
    label: 'Maintenance.CreateM.amount',
    field: 'amount',
    required: false,
    type: 'number',
    value: '',
  },
  {
    label: 'Maintenance.CreateM.replaced_materials',
    field: 'replaced_materials',
    required: false,
    type: 'textarea',
    value: '',
  },
  {
    label: 'Maintenance.CreateM.obeservations',
    field: 'obeservations',
    required: false,
    type: 'textarea',
    value: '',
  },
  {
    title: 'Service.titleProject',
  },
  {
    label: 'Maintenance.CreateM.upload',
    field: 'upload_attachment',
    required: false,
    type: 'file',
    value: '',
    disabled: false,
    src: '',
    format: '',
  },
  {
    label: 'Maintenance.CreateM.upload',
    field: 'upload_attachment_2',
    required: false,
    type: 'file',
    value: '',
    disabled: false,
    src: '',
    format: '',
  }, {
    label: 'Maintenance.CreateM.upload',
    field: 'upload_attachment_3',
    required: false,
    type: 'file',
    value: '',
    disabled: false,
    src: '',
    format: '',
  }
];

export const createCheckList = [
  {
    title: 'Check List Details',
  },
  {
    label: 'Maintenance.CreateM.activity',
    field: 'activity',
    required: false,
    type: 'text',
    value: '',
    requiredText: 'Ativity name is required',
  },
  {
    label: 'Maintenance.CreateM.yes_or_no',
    field: 'yes_or_no',
    required: false,
    type: 'select',
    options: ['Yes', 'No'],
    value: '',
    requiredText: 'Please select Check Status',
  },
  {
    label: 'Maintenance.CreateM.remarks',
    field: 'remarks',
    required: false,
    type: 'text',
    value: '',
  },
];
